import { Box, Button, CircularProgress, FormControl, Grid, Paper, TextField, Typography } from "@mui/material";
import { format } from 'date-fns';
import { useSnackbar } from "notistack";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../../app/store";

import configUrls from "../../../config/configUrls";


import { DocumentoHistoricoAndamentoList } from "../../../types/documento/andamentoHistorico/DocumentoHistoricoAndamentoList";
import { useGetDocumentoHistoricosQuery } from "./DocumentoAtualizarAndamentoApiSlice";
import { useGetDocumentoQuery } from "../createDocumento/documentoApiSlice";
import { Documento, ISdocumento } from "../../../types/processo/Documento";





export const DocumentoAndamentoListForm = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // Hook para navegação



    const [andamentos, setAndamentos] = useState<DocumentoHistoricoAndamentoList[]>([]);


    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum documento selecionado");
            window.location.href = configUrls.PROCESSO_LIST_RT
        }
    }, [processoSelecionado]);


    /*SEARCH*/

    const [search, setSearch] = useState<string>("");
    const [debouncedSearch, setDebouncedSearch] = useState<string>("");
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const cursorPosition = useRef<number>(0);

    const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        cursorPosition.current = inputRef.current?.selectionStart || 0;
        setSearch(e.target.value);
    };

    useEffect(() => {
        // Limpar o timeout anterior
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        // Configurar o timeout para o debounce
        debounceTimeout.current = setTimeout(() => {
           
            setDebouncedSearch(search);
        }, 700); // Tempo de debounce (700ms)

        // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, [search]);

    // FIM DO SEARCH




    const id = useParams().id || "";

    const { data, isFetching, error } = useGetDocumentoHistoricosQuery({ id: id ?? "", search: debouncedSearch });
    useEffect(() => {
        if (data) {
            setAndamentos(data);
        }
        if (error) {
            enqueueSnackbar("Andamentos não encontradas!", { variant: "error" });
        } else if (isFetching) {
            enqueueSnackbar("Buscando registros...", { variant: "info" });
        }
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current?.setSelectionRange(cursorPosition.current, cursorPosition.current);
        }
    }, [data, error, isFetching]);


    const [documento, setDocumento] = useState<Documento>(ISdocumento);
    const { data: dataDoc, isFetching: isFetchingDoc, error: errorDoc } = useGetDocumentoQuery(id || "");
    useEffect(() => {
        if (dataDoc) {
            setDocumento(dataDoc);
        } else if (errorDoc) {
            enqueueSnackbar("Documento não encontrado!", { variant: "error" });
            window.location.href = configUrls.PROCESSO_LIST_RT;
        } else if (isFetchingDoc) {
            enqueueSnackbar("Buscando registro...", { variant: "info" });
        } else {
            enqueueSnackbar("Documento não encontrado!", { variant: "error" });
            window.location.href = configUrls.PROCESSO_LIST_RT;
        }
    }, [dataDoc, errorDoc, isFetchingDoc]);


    if (isFetching) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    const headerGerados = (
        <Typography variant="body2" color="textSecondary">
            Andamento(s) encontrados(s): {andamentos.length}
        </Typography>
    );


    const renderData = (rowData: DocumentoHistoricoAndamentoList) => {
        const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy HH:mm:ss') : "Data não disponível";
        return <Typography color="secondary" variant="body2">{dataCriacao}</Typography>;
    };

    const renderUsuario = (rowData: DocumentoHistoricoAndamentoList) => (
        <Typography color="secondary" variant="body2">{rowData.usuario?.nome || "Usuário não disponível"}</Typography>
    );
    const renderDescricao = (rowData: DocumentoHistoricoAndamentoList) => (
        <Typography color="secondary" variant="body2">{rowData.descricao || ""}</Typography>
    );


    return (
        <>

            <Paper sx={{ width: "100%", height: "100vh", padding: "12px" }}>
                <Grid container padding={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>

                            <Box display="flex" justifyContent="space-between" mb={2}>

                                <Box display="flex">
                                    <Typography color="secondary" variant="h6" gutterBottom>
                                        Andamentos para o documento: {documento.nomeArvore}
                                    </Typography>
                                </Box>


                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => { navigate(`${configUrls.DOCUMENTO_HISTORICO_CREATE_LINK}${documento.id}`) }}
                                    >
                                        Novo
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>


                                </Box>
                            </Box>




                        </FormControl>
                    </Grid>

                    <Grid item xs={12} mt={5} >
                        <FormControl fullWidth>
                            <TextField
                                label="Digite para pesquisar"
                                name="nome"
                                onChange={handleChangeSearch}
                                size="small"
                                inputProps={{ maxLength: 100 }}
                                value={search}
                                inputRef={inputRef}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <DataTable
                    value={andamentos}
                    paginator
                    rows={25}
                    showGridlines={true}
                    size="small"
                    columnResizeMode="expand"
                    resizableColumns
                    dataKey="id"
                    header={headerGerados}
                    className="custom-datatable"
                >

                    <Column header="Data" body={renderData} sortable style={{ width: '20%' }} />
                    <Column header="Descrição" body={renderDescricao} sortable style={{ width: '70%' }} />
                    <Column header="Usuário" body={renderUsuario} sortable style={{ width: '20%' }} />


                </DataTable>


            </Paper>

        </>







    );










};
